import React from "react";

// Checkbox component
const Checkbox = React.forwardRef(({ id, name, label, onChange = null, checked = false, required = false, inputClass = "" }, ref) => (
    <div className="flex items-start space-x-3 font-urbanist">
        <input
            ref={ref}
            type="checkbox"
            id={id}
            name={name}
            className={`form-checkbox text-gray-600 ${inputClass}`}
            required={required}
            checked={checked}
            onChange={onChange}
        />
        <label htmlFor={id} className="text-xs leading-tight max-w-[95%] text-white">
            {label} {required && <span className="text-red-600">*</span>}
        </label>
    </div>
));
export { Checkbox };